export const REQUEST_PERMISSOES = 'GET_PERMISSOES';
export const LISTAR_PERMISSOES = 'LISTAR_PERMISSOES';
export const LISTAR_FUNCIONALIDADES = 'LISTAR_FUNCIONALIDADES';